var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_3642)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#2C3558"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_di_1777_3642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7132 19.0711C24.8099 15.1678 18.4743 15.1678 14.571 19.0711C10.6678 22.9743 10.6678 29.31 14.571 33.2132C18.4743 37.1164 24.8099 37.1164 28.7132 33.2132C32.6164 29.31 32.6164 22.9743 28.7132 19.0711ZM15.9852 20.4853C19.1106 17.3599 24.1735 17.3599 27.2989 20.4853C28.6071 21.7934 29.3637 23.441 29.5688 25.1451H13.7154C13.9205 23.441 14.6771 21.7934 15.9852 20.4853ZM15.9852 31.799C14.6771 30.4908 13.9205 28.8433 13.7154 27.1392H29.5688C29.3637 28.8433 28.6071 30.4908 27.2989 31.799C24.1735 34.9244 19.1106 34.9244 15.9852 31.799Z",
    fill: "#FF2307"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1777_3642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5711 17.0711C27.6678 13.1678 21.3322 13.1678 17.4289 17.0711C13.5257 20.9743 13.5257 27.31 17.4289 31.2132C21.3322 35.1164 27.6678 35.1164 31.5711 31.2132C35.4743 27.31 35.4743 20.9743 31.5711 17.0711ZM18.8431 18.4853C21.9686 15.3599 27.0314 15.3599 30.1569 18.4853C31.465 19.7934 32.2216 21.441 32.4267 23.1451H16.5733C16.7784 21.441 17.535 19.7934 18.8431 18.4853ZM18.8431 29.799C17.535 28.4908 16.7784 26.8433 16.5733 25.1392H32.4267C32.2216 26.8433 31.465 28.4908 30.1569 29.799C27.0314 32.9244 21.9686 32.9244 18.8431 29.799Z",
    fill: "#26F861"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1777_3642",
    x: -40.3564,
    y: -15.8563,
    width: 155.997,
    height: 155.997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.514667 0 0 0 0 0.0666667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_3642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_3642",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.875333 0 0 0 0 0.816667 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow_1777_3642"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1777_3642",
    x: -37.4985,
    y: -17.8563,
    width: 155.997,
    height: 155.997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.514667 0 0 0 0 0.0666667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_3642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_3642",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.875333 0 0 0 0 0.816667 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow_1777_3642"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_3642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolStop);
export default __webpack_public_path__ + "static/media/symbol-stop.830d9d33742cf69fc4c1005667aa880c.svg";
export { ForwardRef as ReactComponent };